import React, { useContext, useState } from 'react';
import { message, Form, Input, Select, Button } from 'antd';
import { Context } from '../../../defaults';
import {
  createStudents,
  getInstitutionById,
  getInstitutionClasses,
  isLoginExist,
} from '../../../actions';
import MaskedInput from 'antd-mask-input';
import {
  emailRegex,
  loginRegex,
  phoneRegex,
  studyYearRegex,
  subjectsRegex,
} from '../../../common';

export function StudentsAdd({ institutions, languagesType, setAdded, setActive }) {
  const [form] = Form.useForm();
  const { dictionary, language, setLoading } = useContext(Context);
  const [institutionClass, setInstitutionClass] = useState();
  const [studyYear, setStudyYear] = useState();
  const [currentRegExp, setCurrentRegExp] = useState('');
  const [currentInstitute, setCurrentInstitute] = useState('');
  const requiredMessage = dictionary?.FillTheField[language];
  const maxLengthMessage = dictionary?.MaxLengthField[language];
  const onlyEnglish = dictionary?.OnlyEnglish[language];
  const invalidEmail = dictionary?.InvalidEmail[language];

  const initialState = {
    lastName: '',
    firstName: '',
    middleName: '',
    institutionId: null,
    langId: null,
    phone: '',
    studyYear: '',
    yearOfStudy: '',
    country: '',
    city: '',
    region: '',
    classId: null,
    users: {
      login: '',
      email: '',
    },
  };

  const onChangeInstitute = (e, data) => {
    setInstitutionClass(null);
    form.setFieldsValue({ classId: null });
    data &&
      data.value &&
      getInstitutionClasses(data.value).then(({ data }) => setInstitutionClass(data));
    getInstitutionById(data.value).then(({ data }) => {
      setCurrentInstitute(data);
      setCurrentRegExp(subjectsRegex(data.studyYearFrom, data.studyYearTo));
    });
  };

  function isNotUniqueLogin() {
    return form.setFields([
      {
        name: 'login',
        value: form.getFieldValue('login'),
        errors: ['Логин должен быть уникальным'],
      },
    ]);
  }

  const onSaveStudent = () => {
    setLoading(true);
    form
      .validateFields()
      .then(() => {
        createStudents(form.getFieldValue())
          .then(() => {
            setLoading(false);
            setAdded(true);
            setActive('2');
            setStudyYear(null);
            message.success(dictionary?.SuccessfullyAdded[language], 4);
            form.resetFields();
          })
          .catch((errors) => {
            if (!!errors.response.data.errors) {
              form.setFields([
                {
                  name: 'login',
                  value: form.getFieldValue('login'),
                  errors: ['Логин должен быть уникальным'],
                },
              ]);
              message.error(errors.response.data.errors.Login, 4);
            } else {
              message.error(dictionary?.SomethingWentWrong[language], 4);
            }
            setLoading(false);
          });
      })
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.FormValidationFail[language], 4);
      });
  };

  function rulesForStudyYear(e) {
    if (!!e) {
      const value = e.target.value;
      const years = value.split('/');
      if (years[0] > years[1]) {
        return {
          validateStatus: 'error',
          help: dictionary?.StudyYearFromLessThanTo[language],
        };
      }
      if (
        Number.isInteger(parseInt(years[0])) &&
        Number.isInteger(parseInt(years[1])) &&
        years[1] - years[0] !== 1
      ) {
        return {
          validateStatus: 'error',
          help: dictionary?.StudyYearValidate[language],
        };
      }
      if (!value.match(studyYearRegex)) {
        return { validateStatus: 'error', help: dictionary?.StudyYearField[language] };
      }
      if (!value) {
        return { validateStatus: 'error', help: requiredMessage };
      } else {
        return { validateStatus: 'success', help: null };
      }
    }
  }

  return (
    <Form
      form={form}
      labelCol={{ span: 7 }}
      wrapperCol={{ span: 12 }}
      layout="horizontal"
      initialValues={initialState}>
      <Form.Item name="id" style={{ display: 'none' }}>
        <Input type={'hidden'} value={null} />
      </Form.Item>
      <Form.Item
        name="institutionId"
        label={dictionary?.Institution[language]}
        rules={[{ required: true, message: requiredMessage }]}>
        <Select
          placeholder={dictionary?.Institution[language]}
          allowClear
          onChange={onChangeInstitute}
          showSearch
          filterOption={(input, option) => {
            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}>
          {institutions &&
            institutions.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.name}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>

      <Form.Item
        label={dictionary?.LastName[language]}
        name="lastName"
        rules={[
          { required: true, message: requiredMessage },
          { min: 1, message: maxLengthMessage },
          { max: 100, message: maxLengthMessage },
        ]}>
        <Input placeholder={dictionary?.LastName[language]} />
      </Form.Item>

      <Form.Item
        label={dictionary?.FirstName[language]}
        name="firstName"
        rules={[
          { required: true, message: requiredMessage },
          { min: 1, message: maxLengthMessage },
          { max: 100, message: maxLengthMessage },
        ]}>
        <Input placeholder={dictionary?.FirstName[language]} />
      </Form.Item>

      <Form.Item
        label={dictionary?.MiddleName[language]}
        name="middleName"
        rules={[
          { min: 1, message: maxLengthMessage },
          { max: 100, message: maxLengthMessage },
        ]}>
        <Input placeholder={dictionary?.MiddleName[language]} />
      </Form.Item>

      <Form.Item
        label={dictionary?.Phone[language]}
        name="phone"
        rules={[
          { required: true, message: requiredMessage },
          { pattern: phoneRegex, message: dictionary?.InvalidPhone[language] },
        ]}>
        <MaskedInput mask="+7 (111) 111-11-11" placeholder="+7 (___) ___-__-__" />
      </Form.Item>
      <Form.Item
        label={dictionary?.UserLogin[language]}
        name="login"
        rules={[
          { required: true, message: requiredMessage },
          { min: 1, message: maxLengthMessage },
          { max: 100, message: maxLengthMessage },
          { pattern: loginRegex, message: onlyEnglish },
        ]}>
        <Input
          placeholder={dictionary?.UserLogin[language]}
          name="login"
          onChange={(e) => {
            isLoginExist(e.target.value)
              .then((res) => res.json())
              .then((res) => res && isNotUniqueLogin());
            form.setFieldsValue({ users: { [e.target.name]: e.target.value } });
          }}
        />
      </Form.Item>
      <Form.Item
        label={dictionary?.Email[language]}
        name="email"
        rules={[
          { required: true, message: requiredMessage },
          { pattern: emailRegex, message: invalidEmail },
        ]}>
        <Input
          placeholder={dictionary?.Email[language]}
          name="email"
          onChange={(e) => {
            form.setFieldsValue({ users: { [e.target.name]: e.target.value } });
          }}
        />
      </Form.Item>
      <Form.Item
        label={dictionary?.StudyYear[language]}
        name="studyYear"
        rules={[
          { required: true, message: requiredMessage },
          {
            pattern: currentRegExp,
            message: dictionary?.InvalidStudyYear[language].replace(
              'diapasone',
              `${currentInstitute.studyYearFrom}-${currentInstitute.studyYearTo}`,
            ),
          },
        ]}>
        <Input placeholder={dictionary?.StudyYear[language]} />
      </Form.Item>

      <Form.Item
        label={dictionary?.YearStudy[language]}
        name="yearOfStudy"
        rules={[{ required: true, message: requiredMessage }]}
        {...rulesForStudyYear(studyYear)}>
        <MaskedInput value={studyYear} onChange={setStudyYear} mask="11/11" placeholder="__/__" />
      </Form.Item>

      <Form.Item
        name="langId"
        label={dictionary?.Lang[language]}
        rules={[{ required: true, message: requiredMessage }]}>
        <Select placeholder={dictionary?.Lang[language]} allowClear={true}>
          {languagesType &&
            languagesType.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.name}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>
      <Form.Item
        label={dictionary?.Country[language]}
        name="country"
        rules={[{ required: true, message: requiredMessage }]}>
        <Input placeholder={dictionary?.Country[language]} />
      </Form.Item>
      <Form.Item
        label={dictionary?.City[language]}
        name="city"
        rules={[{ required: true, message: requiredMessage }]}>
        <Input placeholder={dictionary?.City[language]} />
      </Form.Item>
      <Form.Item
        label={dictionary?.Region[language]}
        name="region"
      // rules={[{ required: true, message: requiredMessage }]}
      >
        <Input placeholder={dictionary?.Region[language]} />
      </Form.Item>
      <Form.Item name="classId" label={dictionary?.Class[language]}>
        <Select placeholder={dictionary?.Class[language]} allowClear>
          {institutionClass &&
            institutionClass.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.year} {el.letter}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 8 }}>
        <Button type="primary" size="large" htmlType="submit" onClick={() => onSaveStudent()}>
          {dictionary?.Save[language]}
        </Button>
      </Form.Item>
    </Form>
  );
}
